import React, { useState, useEffect } from "react";
import { Button, TextField, Box,Grid} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import captchaImg from './assets/grid2.jpg';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '@mui/material/Alert';
export default function Captcha( props ){
    const characters='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const [formValues,setFormValues]=useState({
        user:'',
        isMatched:'',
        error:false,
        captchaInitial:generateString(6)
    })
    function generateString(length){
        let result='';
        const charactersLength=characters.length;
        for(let i=0;i<length;i++){
            result+=characters.charAt(Math.floor(Math.random()*charactersLength));
        }
        return result;
    };

    const verifyCaptcha=()=>{
        if(formValues.captchaInitial===formValues.user){
            setFormValues({...formValues,
            'isMatched':true,
            'showAlert':false,
            'error':false
        })
        }
        else if(formValues.user===''){
            setFormValues({...formValues,
                'isMatched':false,
                'user':'',
                'error':false,
                'showAlert':true,
                'captchaInitial':generateString(6)})
            
        }
        else{
            setFormValues({...formValues,
            'isMatched':false,
            'user':'',
            'showAlert':false,
            'error':true,
            'captchaInitial':generateString(6)})
        }
    };

    useEffect(()=>{ props.validationCheck(formValues.isMatched)},[formValues]);

    const resetCaptcha=()=>{
        setFormValues({
            ...formValues,
            'isMatched':false,
            'user':'',
            'error':false,
            'showAlert':false,
            'captchaInitial':generateString(6)
        })
    };
    
    return(
        <Card variant='outlined' sx={{minWidth:200}}>
            <CardContent>
            <Grid container>
              <Grid item md={6} sx={{ p: "1px", pr: 1 }}>
                <Box sx={{textAlign:'center',minWidth:210,padding:'5px',fontSize:'200%',height:'100%',width:'100%',backgroundImage:`url(${captchaImg})`}}><i>{formValues.captchaInitial}</i></Box>
                </Grid>
                <Grid item md={6} sx={{ p: "1px", pr: 1 }}>
              <TextField
                     variant='filled' 
                     label='Captcha'
                     name='Captcha'
                     value={formValues.user}
                     fullWidth
                     onInput = {(e) =>{
                        e.target.value = e.target.value.toString().slice(0,6)
                    }}
                     onChange={(e)=>setFormValues({...formValues,'user':e.target.value,'showAlert':false})}></TextField>

                     </Grid>
                     {formValues.showAlert ? <Alert variant="outlined" sx={{padding:'0px 10px 0px 10px',fontSize:12}} severity="error">Please enter Captcha</Alert> : null}

                     </Grid>
            </CardContent>
            <CardActions>
            {formValues.isMatched?<CheckCircleIcon color='success'/>:null}
            {formValues.error?<CancelIcon color='error'/>:null}
                <Button color="primary" variant="contained" size='small' onClick={verifyCaptcha} >
                    Verify Captcha
                </Button>
                <Button color="primary" variant="contained" size='small' onClick={resetCaptcha} >
                    Reset Captcha
                </Button>
            </CardActions>
        </Card>
    )
}